import CryptoJS from 'crypto-js'

const mapFlapperUser = (userData) => {
  const user = {
    name: userData.profile?.fullName,
    lastName: '',
    email: userData.emailAddress,
    phone: userData.profile?.mobileNumber
  }
  return user
}

const mapAnonymousUser = (chatData) => {
  const user = {
    ...chatData.user
  }
  return user
}

const getUserFromLocalStorage = () => {
  let user = null
  let flapperUser = window.localStorage.getItem('flapperUser')
  let flapperChat = window.localStorage.getItem('flapperChat')

  let encryptedUserWebAppV3 = window.localStorage.getItem('user-storage')

  encryptedUserWebAppV3 = !!encryptedUserWebAppV3
    ? JSON.parse(encryptedUserWebAppV3)
    : null

  const userWebAppV3 = !!encryptedUserWebAppV3
    ? CryptoJS.AES.decrypt(
        encryptedUserWebAppV3,
        process.env.REACT_APP_LOCALSTORAGE_SECRET_KEY
      ).toString(CryptoJS.enc.Utf8)
    : null



  const localStorageUser = flapperUser || userWebAppV3 ? JSON.parse(userWebAppV3)?.state?.user : null

  try {
    if (localStorageUser?.id) user = mapFlapperUser(localStorageUser)
    else if (flapperChat) user = mapAnonymousUser(JSON.parse(flapperChat))
  } catch (error) {
    console.error('Error trying to get user.')
  }

  return user
}

const saveUserData = (data = {}) => {
  if (data) {
    try {
      let flapperChat =
        JSON.parse(window.localStorage.getItem('flapperChat')) || {}
      flapperChat = { ...flapperChat, user: { ...data } }

      window.localStorage.setItem('flapperChat', JSON.stringify(flapperChat))
    } catch (error) {
      console.error(error)
    }
  }
}

const getUserInfo = () => {
  return getUserFromLocalStorage()
}

export {
  mapFlapperUser,
  mapAnonymousUser,
  getUserFromLocalStorage,
  getUserInfo,
  saveUserData
}
